import { createFileRoute } from "@tanstack/react-router";
import { config } from "@/data/config";
import { redirectIfModuleDisabled } from "@/lib/module-guards";
import { seo } from "@/utils/seo";

export const Route = createFileRoute("/_docs/docs/api-reference/")({
	beforeLoad: () => redirectIfModuleDisabled("public_api", "/"),
	head: () =>
		seo({
			title: "API reference",
			description: `OpenAPI reference for the ${config.siteName} public API at /api/v1.`,
			keywords: "openapi, api reference, rest api, integrations",
		}),
});
